// Shared with the weekly report and Master Reading PDF previews, which
// imported it from here long before the Raffle module was rebuilt.
export const DEFAULT_PDF_ZOOM = 1.5;
